export const props = {
  // Values
  value: undefined,
  type: {
    type: String,
    default: 'text'
  },
  name: String,
  text: String,
  placeholder: String,
  icon: String,
  iconTrailing: String,
  required: Boolean,

  // Status
  turn: Boolean,
  disabled: Boolean
}
